import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = mergeToNew(cartLineQuantityStyles.editableQuantityTextField, {
    css: css`
        border-radius: 6px !important;
    `,
    labelProps: {
        css: css`
            font-size: 14px;
        `,
    },
});
